import React from 'react'
import clsx from 'clsx'
import {useHistory} from 'react-router-dom'
import {makeStyles} from 'external/material'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'

const headCells = [
  // { id: 'created', align: 'left', disablePadding: false},
  { id: 'title', align: 'left', disablePadding: false},
  // { id: 'courseName', align: 'left', disablePadding: false},
  { id: 'groupName', align: 'left', disablePadding: true},
  { id: 'startDate', align: 'center', disablePadding: false},
  { id: 'endDate', align: 'center', disablePadding: false},  
  { id: 'score', align: 'center', disablePadding: false},
  { id: 'files', align: 'center', disablePadding: false, visuallyHidden: true },
  { id: 'received', align: 'left', disablePadding: false},
];

const useStyles = makeStyles(homeworkHeadStyles)


export default function HomeworksHead({context}) {

  const classes = useStyles()
  const history = useHistory()
  const {query, translate, link, linkQuery} = context
  const order = query.orderBy ? (query.orderBy.startsWith('-') ? 'desc' : 'asc') : undefined
  const orderBy = order ? (order == 'asc' ? query.orderBy : query.orderBy.substring(1)) : undefined

  const createSortHandler = (property) => (event) => {
    history.push(linkQuery(
      link('homeworks'),
      {...query, orderBy: `${orderBy == property && order == 'asc' ? '-' : ''}${property}`}
    ))
  }

  return (
    <TableHead>
      <TableRow className={classes.headersRow}>
          {headCells.map(({id, align, disablePadding}) => (
          <TableCell
            key={id}
            align = {align}
            padding={disablePadding ? 'none' : 'normal'}
            sortDirection={order}
            style={{top:92}}
          >
            <TableSortLabel
              className={clsx(classes.headerLabel, id)}
              active={orderBy === id}
              direction={order}
              onClick={createSortHandler(id)}
            >
              {translate(`${id}-header`)}
              {orderBy === id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell className={classes.actions} style={{top:92}} align="right" />
      </TableRow>
    </TableHead>
  )
}


function homeworkHeadStyles() {
    return {
        headersRow: {
          color: '#50566e',
          '& > th': {
            borderTop: 'solid 1px #becfd7',
            backgroundColor: '#ffffff'
          }
        },
        headerLabel: {
          marginLeft: 18,
          color: '#4f576e',
          fontWeight: 500
        },
        visuallyHidden: {
          border: 0,
          clip: 'rect(0 0 0 0)',
          height: 1,
          margin: -1,
          overflow: 'hidden',
          padding: 0,
          position: 'absolute',
          top: 20,
          width: 1,
        },
      };
}
